import(/* webpackMode: "eager" */ "/workspace/src/app/join/page.tsx");
